import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { componentStyles } from "../../Styles/componentStyles";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import { Box } from "@mui/system";
import { Eye, EyeOff } from "lucide-react"; // or @mui/icons-material/Visibility / VisibilityOff

export const TextFieldWithIcon = ({
    value,
    handleLoginInputChange,
    placeholder,
    icon,
    title,
    delay,
    mt,
    type = "text", // default type
    error,
    helperText,
}) => {
    const theme = useTheme();
    const compClass = componentStyles(theme);

    const [showPassword, setShowPassword] = useState(false);

    const animation = {
        initial: { opacity: 0, y: 30 },
        animate: {
            opacity: 1,
            y: 0,
            transition: { duration: 1, delay: delay }
        },
    };

    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <Box mt={mt}>

            <motion.div
                variants={animation}
                initial="initial"
                animate="animate"
            >
                <TextField
                    fullWidth
                    placeholder={placeholder}
                    value={value}
                    type={type === "password" && !showPassword ? "password" : "text"}
                    onChange={handleLoginInputChange(title)}   // if curried handler
                    error={error || false}
                    helperText={error}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">{icon}</InputAdornment>
                            ),
                            endAdornment: type === "password" && (
                                <InputAdornment position="end" sx={{ pr: 1 }}>
                                    <IconButton onClick={handleTogglePassword} edge="end">
                                        {!showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                    sx={{ ...compClass.textFields }}
                />


            </motion.div>
        </Box>
    );
};
